import KeplerRepository from './KeplerRepository';

export default class KeplerService {
	private readonly keplerRepository: KeplerRepository = new KeplerRepository();

	async postGenerateKeplerAnimation(simulationInteractiveId: any, iterationId: any) {
		try {
			return await this.keplerRepository.postGenerateKeplerAnimation(
				simulationInteractiveId,
				iterationId,
			);
		} catch (error) {
			console.error(error);
		}
	}

	async getKeplerAnimation(simulationInteractiveId: any) {
		try {
			return await this.keplerRepository.getKeplerAnimation(simulationInteractiveId);
		} catch (error) {
			console.error(error);
		}
	}

	async getKeplerHistorical(locationId: any) {
		try {
			return await this.keplerRepository.getKeplerHistorical(locationId);
		} catch (error) {
			console.error(error);
		}
	}

	async getSewerAnalysis(locationId: any) {
		try {
			return await this.keplerRepository.getSewerAnalysis(locationId);
		} catch (error) {
			throw error;
		}
	}

	async exportSewerAnalysisExcel(sewerAnalysisId: any) {
		try {
			return await this.keplerRepository.exportSewerAnalysisExcel(sewerAnalysisId);
		} catch (error) {
			console.error(error);
			throw error;
		}
	}

	async deleteSewerAnalysis(sewerAnalysisId: any) {
		try {
			return await this.keplerRepository.deleteSewerAnalysis(sewerAnalysisId);
		} catch (error) {
			console.error(error);
			throw error;
		}
	}

	async postGenerateKeplerHistorical(
		modelId: any,
		startTime: any,
		endTime: any,
		digitalTwinId: any,
		type: any,
		unitSystem: any,
		constraints: any,
		sensorPlacement: any,
		opportunities: any,
	) {
		try {
			return await this.keplerRepository.postGenerateKeplerHistorical(
				modelId,
				startTime,
				endTime,
				digitalTwinId,
				type,
				unitSystem,
				constraints,
				sensorPlacement,
				opportunities,
			);
		} catch (error) {
			console.error(error);
			throw error;
		}
	}
}
